import { useState } from "react";
import { useOnboard } from "@mormlayer/hooks";
import { useAccount } from "wagmi";
import { WalletConnect } from "./WalletConnect";
import { CustomTokenOnboardForm } from "./CustomTokenOnboardForm";
import { GovernanceProposals } from "./GovernanceProposals";
import "./Dashboard.css";

const HKT_NOW = () => {
  const d = new Date();
  return d.toLocaleString("en-HK", { timeZone: "Asia/Hong_Kong", hour12: true });
};

type DashboardSection = "welcome" | "onboard-token" | "governance";

interface DashboardProps {
  apiBaseUrl: string;
  onCreateNewPool: () => void;
  onLaunchPerpMarket: () => void;
}

export function Dashboard({ apiBaseUrl, onCreateNewPool, onLaunchPerpMarket }: DashboardProps) {
  const [section, setSection] = useState<DashboardSection>("welcome");
  const { walletAddress } = useOnboard();
  const { address: wagmiAddress } = useAccount();
  const hasWallet = Boolean(walletAddress || wagmiAddress);

  if (section === "onboard-token") {
    return (
      <CustomTokenOnboardForm
        baseUrl={apiBaseUrl}
        onCancel={() => setSection("welcome")}
      />
    );
  }

  return (
    <div className="dashboard screen">
      <header className="dashboard-header">
        <h1>Morpheum Governance</h1>
        <div className="dashboard-header-right">
          <span className="dashboard-time" title="HKT">
            {HKT_NOW()}
          </span>
          <WalletConnect />
        </div>
      </header>

      <aside className="dashboard-sidebar">
        <nav className="sidebar-nav">

          <button
            type="button"
            className="sidebar-item primary"
            onClick={onCreateNewPool}
          >
            Create New Pool
            (HyperClamm Powered)
          </button>
          <button
            type="button"
            className="sidebar-item"
            onClick={onLaunchPerpMarket}
          >
            Launch Perp Market
            (CLOB Powered)
          </button>
          <button
            type="button"
            className="sidebar-item"
            onClick={() => setSection("onboard-token")}
          >
            Onboard Custom Token
          </button>
          <button
            type="button"
            className={`sidebar-item ${section === "governance" ? "active" : ""}`}
            onClick={() => setSection("governance")}
          >
            Governance
          </button>

        </nav>
      </aside>

      <main className="dashboard-main">
        {section === "welcome" && (
          <p className="dashboard-welcome">
            Create a new spot pair to start trading. Connect your wallet and
            click &quot;Create New Pool&quot; to begin. You can also onboard a
            custom token from the sidebar.
          </p>
        )}
        {section === "governance" && (
          <GovernanceProposals hasWallet={hasWallet} />
        )}
      </main>
    </div>
  );
}
